import { Keyboard, KeyboardResize } from "@capacitor/keyboard";

import { IS_CAPACITOR } from "@src/env";

/**
 * Keep the WebView full-height when the software keyboard opens.
 * Native resize / scroll-assist pans the shell under the status bar / Dynamic Island
 * when using StatusBar overlay + safe-area CSS.
 */
export async function configureCapacitorKeyboard(): Promise<void> {
  if (!IS_CAPACITOR) {
    return;
  }

  try {
    await Keyboard.setResizeMode({ mode: KeyboardResize.None });
    await Keyboard.setScroll({ isDisabled: true });
  } catch {
    // Keyboard plugin may be unavailable in some WebView/simulator configurations.
  }
}
